import { useDispatch, useSelector } from 'react-redux'
import { useState, useEffect, useCallback } from 'react'
import { sagaActions } from '@/redux/sagaActions'
import { RootState } from '@/redux/reducers'

export const useRefreshBalance = () => {
  const dispatch = useDispatch()
  const isUpdating = useSelector((state: RootState) => state.user?.isUpdating)
  const [cooldown, setCooldown] = useState(0)

  const onRefreshClick = useCallback(() => {
    if (cooldown > 0) return // Prevent clicking during cooldown

    dispatch({
      type: sagaActions.USER_FETCH_BALANCE,
    })

    // Start 10 second cooldown
    setCooldown(10)
  }, [dispatch, cooldown])

  // Countdown timer
  useEffect(() => {
    if (cooldown <= 0) return

    const timer = setTimeout(() => {
      setCooldown((prev) => Math.max(0, prev - 1))
    }, 1000)

    return () => clearTimeout(timer)
  }, [cooldown])

  const isDisabled = cooldown > 0 || isUpdating

  return {
    isUpdating,
    onRefreshClick,
    cooldown,
    isDisabled,
  }
}
